var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWidth = function SvgWidth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "width_svg__Layer_1",
    viewBox: "0 0 30 35"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "width_svg__clippath"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-.3h31.2V35H0z",
    className: "width_svg__st0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "width_svg__clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-.3h31.2V35H0z",
    className: "width_svg__st0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "width_svg__clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-.3h31.2V35H0z",
    className: "width_svg__st0"
  })), /*#__PURE__*/React.createElement("style", null, ".width_svg__st0,.width_svg__st1{fill:none}.width_svg__st1{stroke-width:.5px;stroke:#000;stroke-linejoin:bevel}.width_svg__st7{fill:#fff}"))), /*#__PURE__*/React.createElement("path", {
    d: "M29.2 9.4v21.7L9.6 34.5V12.9L20 11z",
    style: {
      fill: "#c6c6c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2 9.4v21.7L9.6 34.5V12.9L20 11z",
    className: "width_svg__st1",
    style: {
      clipPath: "url(#width_svg__clippath)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.2 9.4 20 11 9.6 12.9.5 3.7 20 .3z",
    className: "width_svg__st7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.2 9.4 20 11 9.6 12.9.5 3.7 20 .3z",
    className: "width_svg__st1",
    style: {
      clipPath: "url(#width_svg__clippath-1)"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6 12.9v21.6L.5 25.4V3.7z",
    className: "width_svg__st7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.6 12.9v21.6L.5 25.4V3.7z",
    className: "width_svg__st1",
    style: {
      clipPath: "url(#width_svg__clippath-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.4 23.4 14.9-2.8",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7 23.1 26 20.8",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m16.7 25.7.4-.7-3.1-1.9 2.2-3-.6-.4-2.7 3.6zM24.1 24.3l-.6-.4 2.2-3-3.1-2 .4-.6 3.8 2.4z"
  })));
};
export { SvgWidth as ReactComponent };
export default "data:image/svg+xml;base64,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";